import { request } from './core'

export interface SettingDef {
  key: string
  label: string
  group: string
  kind: 'text' | 'secret' | 'number' | 'bool'
  required: boolean
  help: string
  multiline?: boolean // render as a textarea (e.g. a PEM private key)
  options?: { value: string; label: string }[] // non-empty → render a dropdown
  from_db: boolean
  value?: string // non-secrets only
  is_set?: boolean // secrets only — never the value
}

export interface SettingsResponse {
  settings: SettingDef[]
  configured: boolean
  missing: string[]
}

export const settingsApi = {
  getSettings: () => request<SettingsResponse>('/api/admin/settings'),

  /** Omit a key to leave it unchanged; send "" to clear (reverts to env/default). */
  updateSettings: (updates: Record<string, string>) =>
    request<SettingsResponse>('/api/admin/settings', {
      method: 'PUT',
      body: JSON.stringify({ updates }),
    }),
}
